/*
 * @Author: Dom
 * @Date: 2022-05-30 15:49:05
 * @LastEditTime: 2022-07-13 14:08:14
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\logistics\logisticsquery\service.ts
 */
import request from '@/utils/request';
import {TableListQueryParams, OrderInfoParams, updateOrderType,addLogisticsType, orderBatchLabelType, getEventCodeListType} from './data.d'

export async function getOrderAddressPageList(params:TableListQueryParams): Promise<any> {
    return request({
        url: '/seller/v1/order/getOrderPageList',
        method: 'POST',
        data: params,
    });
}

export async function getorderInfo(params:OrderInfoParams): Promise<any> {
    return request({
        url: '/seller/v1/order/orderInfo',
        method: 'POST',
        data: params,
    });
}

export async function orderLabel(params:any): Promise<any> {
    return request({
        url: '/seller/v1/order/orderLabel',
        method: 'POST',
        data: params,
    });
}

export async function updateOrder(params:any): Promise<any> {
    return request({
        url: '/seller/v1/order/updateOrderOddNumbers',
        method: 'POST',
        data: params,
    });
}

//取消订单
export async function orderCancel(params:updateOrderType): Promise<any> {
    return request({
        url: '/seller/v1/order/orderCancel',
        method: 'GET',
        params,
    });
}

// 物流轨迹
export async function getAddLogistics(params:addLogisticsType): Promise<any> {
    return request({
        url: '/seller/v1/orderEvent/getOrderEventList',
        method: 'POST',
        data: params,
    });
}

// 批量打印面单
export async function orderBatchLabel(params:orderBatchLabelType): Promise<any> {
    return request({
        url: '/seller/v1/order/orderBatchLabel',
        method: 'POST',
        data: params,
    });
}

// 批量取消物流单
export async function orderBatchCancel(params:orderBatchLabelType): Promise<any> {
    return request({
        url: '/seller/v1/order/orderBatchCancel',
        method: 'POST',
        data: params,
    });
}

export async function getEventCodeList(params:getEventCodeListType): Promise<any> {
    return request({
        url: '/seller/v1/pms/event_code/getEventCodeList',
        method: 'GET',
        params,
    });
}


//批量下载面单
export async function downLabels(params:any): Promise<any> {
    return request({
        url: '/oms/v1/orderLabel/downLabels',
        method: 'POST',
        data: params,
    });
}
